import { render, staticRenderFns } from "./UploadEmployee.vue?vue&type=template&id=5dc8f00e"
import script from "./UploadEmployee.vue?vue&type=script&lang=js"
export * from "./UploadEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports